import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Table, Button, Badge, Spinner, Alert } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardTeacher, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useSchool } from '../../contexts/SchoolContext';
import { useAcademicYear } from '../../contexts/AcademicYearContext';
import { useAuth } from '../../contexts/AuthContext';
import SchoolUserService from '../../services/schoolUser.service';

const TeacherClasses = () => {
  const { user } = useAuth();
  const { selectedSchool } = useSchool();
  const { selectedYear } = useAcademicYear();
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (selectedSchool && selectedYear && user?.id) {
      fetchTeacherClasses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSchool, selectedYear, user]);

  const fetchTeacherClasses = async () => {
    try {
      setLoading(true);
      setError(null);

      // Buscar atribuições do professor (turmas + disciplinas)
      // Backend filtra automaticamente baseado no papel do usuário
      const response = await SchoolUserService.getTeacherAssignments({
        school: selectedSchool,
        year: selectedYear
      });

      setClasses(response.results || []);
    } catch (err) {
      console.error('Error fetching teacher classes:', err);
      setError('Erro ao carregar turmas. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const getClassName = (classItem) => {
    return `${classItem.classroom_grade} - ${classItem.classroom_education_level} ${classItem.classroom_name}`;
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <h4>Minhas Turmas - {selectedYear}</h4>
          <p className="mb-0">Turmas e disciplinas que você leciona</p>
        </div>
      </div>

      <Row>
        <Col xs={12} className="mb-4">
          <Card border="light" className="shadow-sm">
            <Card.Header>
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0">
                    <FontAwesomeIcon icon={faChalkboardTeacher} className="me-2" />
                    Lista de Turmas
                  </h5>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              {loading && (
                <div className="text-center py-5">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Carregando...</span>
                  </Spinner>
                </div>
              )}
              {error && (
                <Alert variant="danger" className="m-3">
                  {error}
                </Alert>
              )}
              {!loading && !error && classes.length === 0 && (
                <div className="text-center py-5">
                  <p className="text-muted">Nenhuma turma encontrada para este ano letivo.</p>
                </div>
              )}
              {!loading && !error && classes.length > 0 && (
                <Table responsive hover className="align-items-center table-flush mb-0">
                  <thead className="thead-light">
                    <tr>
                      <th>Turma</th>
                      <th>Disciplina</th>
                      <th>Turno</th>
                      <th>Alunos</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {classes.map((classItem, index) => (
                      <tr key={index}>
                        <td className="fw-bold">
                          {getClassName(classItem)}
                        </td>
                        <td>
                            {classItem.subject_name || '-'}
                        </td>
                        <td>{classItem.classroom_shift || '-'}</td>
                        <td>
                          <Badge bg="secondary">
                            <FontAwesomeIcon icon={faUsers} className="me-1" />
                            {classItem.students_count || 0}
                          </Badge>
                        </td>
                        <td>
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={() => {
                              // TODO: Navegar para detalhes da turma
                              console.log('Ver turma:', classItem);
                            }}
                          >
                            Ver Alunos
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default TeacherClasses;
